import { render } from "./vue3-video-player.vue?vue&type=template&id=25bfbdb0"
import script from "./vue3-video-player.vue?vue&type=script&lang=js"
export * from "./vue3-video-player.vue?vue&type=script&lang=js"

import "./vue3-video-player.vue?vue&type=style&index=0&id=25bfbdb0&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__